import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { templateMspInProductTrialsStartTrialPopUp } from '../view/template';
import { MspInProductTrialsStartTrialPopUpWebComponent } from '../component/MspInProductTrialsStartTrialPopUpWebComponent';
import { MspInProductTrialsStartTrialPopUpWebView } from '../view/MspInProductTrialsStartTrialPopUpWebView';
import { CompanyDetailsFormRepository } from '../../../../company/common/companyDetailsForm/repository/CompanyDetailsFormRepository';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';
import { MspInProductTrialId } from '../../../../company/common/mspInProductTrialsTab/types/msp-in-product-trials-types';

export class MspInProductTrialsStartTrialPopUpWebController extends BaseWebComponentController {
  public component: MspInProductTrialsStartTrialPopUpWebComponent;
  public view: MspInProductTrialsStartTrialPopUpWebView;
  public viewConstructor: typeof MspInProductTrialsStartTrialPopUpWebView;
  public dataRepository: CompanyDetailsFormRepository;
  public dataRepositoryConstructor: typeof CompanyDetailsFormRepository;

  constructor(component: MspInProductTrialsStartTrialPopUpWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: MspInProductTrialsStartTrialPopUpWebView,
      viewTemplate: templateMspInProductTrialsStartTrialPopUp,
      dataRepositoryConstructor: CompanyDetailsFormRepository,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [];
  }

  public async getDataForView() {
    const countries = this.dataRepository.getCountries();
    const states = this.dataRepository.getStates();
    const industries = this.dataRepository.getIndustries();

    const promises: Promise<any>[] = [countries, states, industries];

    const viewData = await Promise.all(promises);

    return {
      countries: viewData[0],
      states: viewData[1],
      industries: viewData[2],
    };
  }

  public getFormGroup(): FormGroup {
    return this.view.getFormGroup();
  }

  public setFormGroupValues(formGroupValue: FormGroupValue): void {
    this.view.setFormGroupValues(formGroupValue);
  }

  public setContext(context: MspInProductTrialId) {
    this.view.setContext(context);
  }
}
